import styled from 'styled-components';

export const StyledCross = styled.button<{
  margin?: string;
}>`
  margin: ${(props) => props.margin ?? '0'};
  background-color: inherit;
  border: none;
  cursor: pointer;
  &:hover {
    img {
      filter: invert(100%) sepia(95%) saturate(14%) hue-rotate(209deg)
        brightness(104%) contrast(100%);
    }
  }
  align-self: flex-end;
  padding: 0px;
`;
